export function getExerciseKey(ex) {
  if (!ex) return null;
  return ex.exercise_id || ex.id || ex.name || null;
}
